<template>
  <div>
    <v-text-field
      clearable
      :label="label"
      v-model="value"
      @click="presentCombobox()"
    ></v-text-field>

    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title
            :style="{
              color: 'white',
              'background-color': getThemeColor,
            }"
            >Select {{ label }}</v-card-title
          >

          <v-autocomplete
            class="mx-10"
            :items="rowData"
            :label="label"
            v-model="selectedRowValue"
          ></v-autocomplete>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <vButton
              color="red"
              :small="true"
              label="Cancel"
              icon="mdi-cancel"
              :outlined="true"
              @button-clicked="dialog = false"
            ></vButton>
            <vButton
              class="ml-2"
              color="green"
              :small="true"
              label="Submit"
              icon="mdi-check"
              :outlined="true"
              @button-clicked="submitSelection"
            ></vButton>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import mainJs from "../main";
import vButton from "./vButton.vue";

export default {
  props: {
    foreignTablesArray: {
      default: () => [],
    },
    foreignKeysArray: {
      default: () => [],
    },
    foreignColumn: {
      default: null,
    },
    foreignFieldValue: {
      default: null,
    },
    branchID: {
      default: null,
    },
  },
  watch: {
    async table(newTable) {
      if (this.foreignFieldValue && newTable) {
        this.value = await this.getForeignFieldValue(
          newTable,
          this.foreignFieldValue
        );
      }
    },
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getForeignFieldValueRoute() {
      return this.$store.getters.getForeignFieldValueRoute;
    },
    getForeignKeyDataRoute() {
      return this.$store.getters.getForeignKeyDataRoute;
    },
  },
  components: { vButton },
  async mounted() {
    await this.getForeignTable(
      this.foreignColumn,
      this.foreignTablesArray,
      this.foreignKeysArray
    );
  },
  data() {
    return {
      rowData: [],
      dialog: false,
      selectedRowValue: null,
      value: null,
      table: null,
      label: null,
    };
  },
  methods: {
    formatTableName(name) {
      return mainJs.formatUnderscoreNamesWithFirstCapitalLetters(name);
    },
    async getForeignTable(foreignColumn, foreignTablesArray, foreignKeysArray) {
      if (foreignTablesArray && foreignTablesArray.length > 0) {
        this.label = this.formatTableName(foreignColumn);
        this.table =
          foreignTablesArray[foreignKeysArray.indexOf(foreignColumn)];
        if (this.foreignFieldValue && this.table) {
          this.value = await this.getForeignFieldValue(
            this.table,
            this.foreignFieldValue
          );
        }
      } else {
        this.table = null;
      }
    },
    async getForeignFieldValue(table, foreignFieldValue) {
      this.$store.commit("setLoader", true);
      const name = await mainJs.getForeignFieldValue(
        this.getApiUrl + this.getForeignFieldValueRoute,
        table,
        foreignFieldValue,
        this.getAccessToken
      );
      this.$store.commit("setLoader", false);
      return name;
    },
    async presentCombobox() {
      this.$store.commit("setLoader", true);
      const branchID = this.branchID ? this.branchID : null;
      const rowData = await mainJs.getForeignTableData(
        this.getApiUrl + this.getForeignKeyDataRoute,
        this.table,
        this.foreignColumn,
        this.getAccessToken,
        branchID
      );

      this.rowData = [];
      rowData.forEach((row) => {
        this.rowData.push({
          text: row.name,
          value: `${row.id} +! ${row.name}`,
        });
      });

      this.$store.commit("setLoader", false);
      this.dialog = true;
    },
    submitSelection() {
      const vals = this.selectedRowValue.split("+!");
      this.value = vals[1];
      this.$emit("field-selected", vals);
      this.dialog = false;
    },
  },
};
</script>

<style></style>
